/**
 * @generated SignedSource<<9f3e439b727e812013b2aa503426fcb9>>
 * @relayHash 5cfab9bda18dc70937215279bf266894
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5dc14d9b45658d763ede1d20f6cacfc41b556c2ecf39a4ccda0838f765d1f529

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AlertsContentViewQuery$variables = {
  cloudId: string;
};
export type AlertsContentViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AlertsMenuItemContent">;
};
export type AlertsContentViewQuery = {
  response: AlertsContentViewQuery$data;
  variables: AlertsContentViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "alertSearchQuery"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AlertsContentViewQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "AlertsMenuItemContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlertsContentViewQuery",
    "selections": [
      {
        "concreteType": "OpsgenieQuery",
        "kind": "LinkedField",
        "name": "opsgenie",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "OpsgenieSavedSearches",
            "kind": "LinkedField",
            "name": "savedSearches",
            "plural": false,
            "selections": [
              {
                "concreteType": "OpsgenieSavedSearch",
                "kind": "LinkedField",
                "name": "sharedWithMe",
                "plural": true,
                "selections": (v1/*: any*/)
              },
              {
                "concreteType": "OpsgenieSavedSearch",
                "kind": "LinkedField",
                "name": "createdByMe",
                "plural": true,
                "selections": (v1/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5dc14d9b45658d763ede1d20f6cacfc41b556c2ecf39a4ccda0838f765d1f529",
    "metadata": {},
    "name": "AlertsContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "96a759ca18187799c882e6cb40f5d4a4";

export default node;
